import { apiResource } from '@/util/resources'
import moment from 'moment'

export default {
  state: {
    debts: [],
    payments: [],
    paymentPlans: [],
    unconfirmedPaymentPlans: [],
    unconfirmedReconciliationPaymentPlans: [],
    summary: {},
    bankAccount: {},
    seenVerdictAvailableMessage: false,
    showVerdictSentDialog: false,
    verdictLoading: false
  },
  actions: {
    transferDueDate ({ commit }, payload) {
      return new Promise((resolve, reject) => {
        apiResource.post('api/duedate/transfer', payload).then((response) => {
          resolve(response.data)
        }, error => {
          commit('setMessage', { type: 'error', text: 'Eräpäivän siirrossa tapahtui virhe' })
          reject(error)
        })
      })
    },
    signVerdict ({ commit }, data) {
      commit('clearError')
      return new Promise((resolve, reject) => {
        apiResource.post('api/judgement/judgementUrl', data).then((response) => {
          resolve(response.data)
        }, error => {
          commit('setMessage', { type: 'error', text: 'error.server.0', translate: true })
          reject(error)
        })
      })
    },
    confirmSuggestedPaymentPlan({ commit }, payload) {
      return new Promise((resolve, reject) => {
        commit('setLoading', true)

        apiResource.post('api/orders/confirmSuggestedPaymentPlan', payload).then((response) => {
          commit('setLoading', false)
          if (response.data !== null) {
            resolve(response.data)
          } else {
            reject()
          }
        }, error => {
          commit('setLoading', false)
          reject(error)
        })
      })
    }
  },
  mutations: {
    setDebts (state, payload) {
      state.debts = payload
    },
    setPayments (state, payload) {
      let payments = []
      payload.forEach((debt) => {
        if (debt.payments.length > 0) {
          debt.payments.forEach((payment) => {
            payments.push(payment)
          })
        }
      })
      state.payments = payments
    },
    setPaymentPlans (state, payload) {
      let confirmedPaymentPlans = payload.filter(function (pp) {
        return pp.paymentPlanType === 0 ||
          pp.paymentPlanType === 2 ||
          pp.paymentPlanType === 3 ||
          pp.paymentPlanType === 5 ||
          pp.paymentPlanType === 7
      })

      let unconfirmedPaymentPlans = payload.filter(function (pp) {
        return pp.paymentPlanType === 1 || pp.paymentPlanType === 4
      })

      let unconfirmedReconciliationPaymentPlans = payload.filter(function (pp) {
        return pp.paymentPlanType === 6
      })

      state.paymentPlans = confirmedPaymentPlans
      state.unconfirmedPaymentPlans = unconfirmedPaymentPlans
      state.unconfirmedReconciliationPaymentPlans = unconfirmedReconciliationPaymentPlans
    },
    setSummary (state, payload) {
      state.summary = payload
    },
    setBankAccount (state, payload) {
      state.bankAccount = payload[0]
    },
    setDueDate (state, payload) {
      let debt = state.debts.find((debt) => {
        return debt.orderNr === payload.DebtNr
      })
      debt.dueDate = payload.NewDuedate
    },
    setReclamationRequested (state, payload) {
      let debt = state.debts.find((debt) => {
        return debt.orderNr === payload.DebtNr
      })
      debt.debtSummary.state.state = 12
      // debt.reclamationRequested = moment().format('YYYY-MM-DD')
    },
    setShowVerdictSentDialog (state, payload) {
      state.showVerdictSentDialog = payload
    },
    setVerdictLoading(state, payload) {
      state.verdictLoading = payload
    },
    logoutDebts (state) {
      state.debts = []
      state.payments = []
      state.paymentPlans = []
      state.unconfirmedPaymentPlans = []
      state.summary = {}
      state.bankAccount = {}
    },
    setSeenVerdictAvailableMessage (state, payload) {
      state.seenVerdictAvailableMessage = payload
    },
    addPaymentPlan(state, payload) {
      let pp = state.unconfirmedPaymentPlans.find((paymentPlan) => {
        return paymentPlan.nr === payload
      })
      pp.paymentPlanType = 2
      state.paymentPlans.push(pp)
      state.unconfirmedPaymentPlans.splice(pp)
    },
    removePaymentPlan(state, payload) {
      let pp = state.unconfirmedPaymentPlans.find((paymentPlan) => {
        return paymentPlan.nr === payload
      })
      state.unconfirmedPaymentPlans.splice(pp)
    }
  },
  getters: {
    allDebts (state) {
      let allDebts = state.debts.sort((a, b) => {
        return a.debtSummary.state.order - b.debtSummary.state.order || moment(a.dueDate).format('X') - moment(b.dueDate).format('X')
      })

      allDebts.forEach((debt) => {
        debt.paymentPlan = null
        debt.unconfirmedPaymentPlan = null
      })

      state.paymentPlans.forEach((plan) => {
        plan.debts.forEach((d) => {
          let debt = allDebts.find((debt) => {
            return debt.nr === d.nr
          })

          if (debt !== null) {
            debt.paymentPlan = plan
          }
        })
      })

      state.unconfirmedPaymentPlans.forEach((plan) => {
        plan.debts.forEach((d) => {
          let debt = allDebts.find((debt) => {
            return debt.nr === d.nr
          })

          if (debt !== null) {
            debt.unconfirmedPaymentPlan = plan
          }
        })
      })

      return allDebts
    },
    openDebts (state, getters) {
      let openDebts = getters.allDebts.filter(function (debt) {
        return debt.debtSummary.state.ended === false
      })
      return openDebts
    },
    openDebtsWithoutPaymentPlan (state, getters) {
      let openDebtsWithoutPaymentPlan = getters.openDebts.filter(function (debt) {
        return debt.paymentPlan === null
      })
      return openDebtsWithoutPaymentPlan
    },
    paymentPlans (state) {
      return state.paymentPlans
    },
    paidDebts (state, getters) {
      let paidDebts = getters.allDebts.filter(function (debt) {
        return debt.debtSummary.state.ended === true
      })
      return paidDebts
    },
    singleDebt (state, getters) {
      return (orderNr) => {
        return getters.allDebts.find((debt) => {
          return debt.orderNr === orderNr
        })
      }
    },
    getSingleDebt: (state, getters) => (orderNr) => {
      return getters.allDebts.find(debt => debt.orderNr === orderNr)
    },
    getDebts: (state, getters) => (orderNrs) => {
      let debts = []
      orderNrs.forEach((orderNr) => {
        debts.push(getters.singleDebt(orderNr))
      })
      return debts
    },
    paymentPlan (state) {
      return (nr) => {
        return state.paymentPlans.find((paymentPlan) => {
          return paymentPlan.nr === nr
        })
      }
    },
    reconciliationPlan (state) {
      return (nr) => {
        return state.unconfirmedReconciliationPaymentPlans.find((paymentPlan) => {
          return paymentPlan.nr === nr
        })
      }
    },
    latestPaymentPlan (state) {
      let sortedPaymentPlans = state.paymentPlans.sort((a, b) => {
        return b.nr - a.nr
      })

      if (sortedPaymentPlans.length) {
        return sortedPaymentPlans[0]
      } else {
        return null
      }
    },
    payments (state) {
      return state.payments.sort((a, b) => {
        return a.paymentDate > b.paymentDate
      })
    },
    bankAccount (state) {
      return state.bankAccount
    },
    summary (state, getters) {
      return {
        total: state.summary.total,
        left: state.summary.left,
        totalPaid: state.summary.totalPaid,
        progress: parseFloat(((state.summary.totalPaid / state.summary.total) * 100).toFixed(2)),
        count: getters.openDebts.length,
        collectingCosts: state.summary.collectingCosts,
        otherCosts: state.summary.otherCosts,
        interest: state.summary.interest
      }
    },
    hasOnlyOneDebt (state) {
      return state.debts.length === 1
    },
    singleDebtNr (state, getters) {
      return getters.hasOnlyOneDebt ? getters.allDebts[0].nr : 0
    },
    canCreateAJointPlan (state, getters) {
      let testDebts = getters.openDebtsWithoutPaymentPlan.filter(function (debt) {
        return debt.paymentPlan === null && debt.paymentPlanParameters.allow
      })
      return testDebts.length >= 2
    },
    showVerdictSentDialog (state) {
      return state.showVerdictSentDialog
    },
    verdictLoading (state) {
      return state.verdictLoading
    }, 
    verdictAvailableDebts (state, getters) {
      let debts = getters.allDebts.filter(function (debt) {
        return debt.isVerdictAvailable === true && debt.verdictDate !== null && debt.verdictDate !== '' && debt.isVerdictDownloaded === false
      })

      return debts
    },
    verdictRecentAvailableDebts (state, getters) {
      let debts = getters.verdictAvailableDebts.filter(function (debt) {
        return moment(debt.verdictDate).diff(moment(), 'months') === 0
      })

      return debts
    },
    seenVerdictAvailableMessage (state) {
      return state.seenVerdictAvailableMessage
    }
  }
}
